import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShoppingBagProductDetailsQuery } from './getShoppingBagProductDetails';

const useShoppingBagProductDetailsQuery = skuIds => {
  const {
    data: shoppingBagProductDetailsData,
    loading: shoppingBagProductDetailsLoading,
    error: shoppingBagProductDetailsError,
  } = useGetShoppingBagProductDetailsQuery({
    skip: !skuIds?.length,
    variables: {
      skuIds,
    },
    onCompleted: () => {
      recordMark('get_shopping_bag_product_details_graph_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('get_shopping_bag_product_details_graph_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(
        `GetShoppingBagProductDetails error for sku IDs ${skuIds}: ${shoppingBagProductDetailsError}`,
        {
          skuIds,
          error_message: shoppingBagProductDetailsError,
        },
      );
    },
  });

  return {
    shoppingBagProductDetailsData,
    shoppingBagProductDetailsLoading,
    shoppingBagProductDetailsError,
  };
};

export default useShoppingBagProductDetailsQuery;
